import * as React from "react";
import type { SVGProps } from "react";
const SvgSmallHouse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.57 2.18a.974.974 0 0 0-.92-.11L7 6.81V5c0-.55-.45-1-1-1s-1 .45-1 1v2.56l-1.35.51c-.39.15-.65.52-.65.94v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-5h2v5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V3c0-.33-.16-.63-.43-.82ZM19 20h-4v-5c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v5H5V9.69l14-5.25V20Z"
    />
  </svg>
);
export default SvgSmallHouse;
